import { AVAILABLE_LOCALES as g } from "../../../i18n/initializer.js";
import { TranslationProviderBackend as d } from "./TranslationProvider.backend.js";
import { installMissingKeyRegistry as y } from "./TranslationProvider.missingKeys.js";
import { useEffect as I, useState as i } from "react";
import { jsx as v } from "react/jsx-runtime";
import { I18nextProvider as L } from "react-i18next";
import { createInstance as E } from "i18next";
var k = ({ children: l, loadAppNamespace: s, fallback: o = null, ...e }) => {
  const [f, t] = i(!1), [r, u] = i(null);
  return I(() => {
    let a = !0;
    async function c() {
      if (!e.lng || !g.includes(e.lng)) {
        t(!1);
        return;
      }
      const m = new d(s);
      if (r)
        await r.changeLanguage(e.lng), a && t(!0);
      else {
        const n = E();
        u(n), await n.use(m).init({
          saveMissing: !0,
          returnEmptyString: !1,
          missingKeyHandler: y(n),
          ...e,
          lng: e.lng,
          ns: ["general"]
        }), n.loadNamespaces("general"), a && t(!0);
      }
    }
    return c(), () => {
      a = !1;
    };
  }, [e.lng, s]), !f || !r ? o : /* @__PURE__ */ v(L, {
    i18n: r,
    children: l
  });
};
export {
  k as TranslationProvider
};

//# sourceMappingURL=TranslationProvider.js.map